import { GenericLookupTypeDto } from 'src/core/models/generic-lookup-type/generic-lookup-type.dto';

export class DataChange {
    static readonly type = '[GenericLookupTypeService] DataChange';

    constructor(public payload: GenericLookupTypeDto[]) {}
}
